import { render } from "./AccordionItemEditor.vue?vue&type=template&id=5ecee4e0&scoped=true&lang=pug"
import script from "./AccordionItemEditor.vue?vue&type=script&lang=js"
export * from "./AccordionItemEditor.vue?vue&type=script&lang=js"

import "./AccordionItemEditor.vue?vue&type=style&index=0&id=5ecee4e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecee4e0"]])

export default __exports__